import GeneratorEntity from './../models/Generator';

export  const exportGeneratorToJson = (objectData: GeneratorEntity) =>  {
  const filename = "generator.json";
  const contentType = "application/json;charset=utf-8;";
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    const blob = new Blob([decodeURIComponent(encodeURI(JSON.stringify(objectData, null,'\t')))], { type: contentType });
    navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    const a = document.createElement('a');
    a.download = filename;
    a.href = 'data:' + contentType + ',' + encodeURIComponent(JSON.stringify(objectData, null,'\t'));
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}



// WEBPACK FOOTER //
// ./src/utils/imUndExport.ts